module.exports = __webpack_public_path__ + "assets/language-squares/es@2x-76df3c4bc5cdb280e4890f9ae97da1cd.jpg";